export const APPRECIATION = "APPRECIATION";
export const APPRECIATION_SUCCESS = "APPRECIATION_SUCCESS";
export const APPRECIATION_FAILED = "APPRECIATION_FAILED";

export const ADD_APPRECIATION = "ADD_APPRECIATION";
export const ADD_APPRECIATION_SUCCESS = "ADD_APPRECIATION_SUCCESS";
export const ADD_APPRECIATION_FAILED = "ADD_APPRECIATION_FAILED";

export const UPDATE_APPRECIATION = "UPDATE_APPRECIATION";
export const UPDATE_APPRECIATION_SUCCESS = "UPDATE_APPRECIATION_SUCCESS";
export const UPDATE_APPRECIATION_FAILED = "UPDATE_APPRECIATION_FAILED";